/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AttachmentExcludeIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Attachment Exclude',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M15.77 22.036c-.821-.82-.176-1.569.526-2.271.267-.267 8.248-8.238 9.673-9.659a.731.731 0 0 0 .013-1.021l-.674-.718a.734.734 0 0 0-1.056-.015L14.3 18.344a3.631 3.631 0 0 0-.071 5.469 3.876 3.876 0 0 0 .778.6 12.161 12.161 0 0 1 .787-2.358Z"
    />
    <path
      d="M15.706 31.97a6.6 6.6 0 0 1-4.227 1.557h-.106a6.972 6.972 0 0 1-4.826-2.075 6.765 6.765 0 0 1-.106-9.661l17.78-17.8a4.874 4.874 0 0 1 3.133-1.479A3.723 3.723 0 0 1 30.4 3.631 3.54 3.54 0 0 1 31.517 6.7a5.732 5.732 0 0 1-1.584 3l-5.348 5.34a12.237 12.237 0 0 1 3.7-.172l3.411-3.4c2.509-2.5 3.471-6.6.473-9.6A6.227 6.227 0 0 0 27.59 0a7.274 7.274 0 0 0-5.133 2.227L4.76 19.9a9.415 9.415 0 0 0 12.191 14.278 12.231 12.231 0 0 1-1.245-2.208Z"
    />
    <path
      d="M27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9ZM20 27a6.929 6.929 0 0 1 1.475-4.252l9.777 9.777A6.966 6.966 0 0 1 20 27Zm12.525 4.252-9.777-9.777a6.966 6.966 0 0 1 9.777 9.777Z"
    />
  </svg>`;
};
